var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SurveyQuestionElementBase } from "./reactquestion_element";
import * as React from "react";
import { SurveyElementBase } from "./reactquestion_element";
import { SvgIcon } from "./components/svg-icon/svg-icon";
import { ButtonGroupItemModel, } from "survey-core";
import { ReactQuestionFactory } from "./reactquestion_factory";
var SurveyQuestionButtonGroup = /** @class */ (function (_super) {
    __extends(SurveyQuestionButtonGroup, _super);
    function SurveyQuestionButtonGroup(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyQuestionButtonGroup.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionButtonGroup.prototype.getStateElement = function () {
        return this.question;
    };
    SurveyQuestionButtonGroup.prototype.renderElement = function () {
        var items = this.renderItems();
        return React.createElement("div", { className: this.question.cssClasses.root }, items);
    };
    SurveyQuestionButtonGroup.prototype.renderItems = function () {
        var _this = this;
        return this.question.visibleChoices.map(function (item, index) {
            return (React.createElement(SurveyButtonGroupItem, { key: _this.question.inputId + "_" + index, item: item, question: _this.question, index: index }));
        });
    };
    return SurveyQuestionButtonGroup;
}(SurveyQuestionElementBase));
export { SurveyQuestionButtonGroup };
ReactQuestionFactory.Instance.registerQuestion("buttongroup", function (props) {
    return React.createElement(SurveyQuestionButtonGroup, props);
});
var SurveyButtonGroupItem = /** @class */ (function (_super) {
    __extends(SurveyButtonGroupItem, _super);
    function SurveyButtonGroupItem(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyButtonGroupItem.prototype, "index", {
        get: function () {
            return this.props.index;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyButtonGroupItem.prototype, "question", {
        get: function () {
            return this.props.question;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyButtonGroupItem.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    SurveyButtonGroupItem.prototype.getStateElement = function () {
        return this.item;
    };
    SurveyButtonGroupItem.prototype.renderElement = function () {
        this.model = new ButtonGroupItemModel(this.question, this.item, this.index);
        var icon = this.renderIcon();
        var input = this.renderInput();
        var caption = this.renderCaption();
        return (React.createElement("label", { className: this.model.css.label, title: this.model.caption.renderedHtml },
            input,
            React.createElement("div", { className: this.model.css.decorator },
                icon,
                caption)));
    };
    SurveyButtonGroupItem.prototype.renderIcon = function () {
        if (!!this.model.iconName) {
            return (React.createElement(SvgIcon, { className: this.model.css.icon, iconName: this.model.iconName, size: this.model.iconSize || 24 }));
        }
        return null;
    };
    SurveyButtonGroupItem.prototype.renderInput = function () {
        var _this = this;
        return (React.createElement("input", { className: this.model.css.control, id: this.model.id, type: "radio", name: this.model.name, checked: this.model.selected, value: this.model.value, disabled: this.model.readOnly, onChange: function () {
                _this.model.onChange();
            }, "aria-required": this.model.isRequired, "aria-label": this.model.caption.renderedHtml, "aria-invalid": this.model.hasErrors, "aria-errormessage": this.model.describedBy }));
    };
    SurveyButtonGroupItem.prototype.renderCaption = function () {
        if (!this.model.showCaption)
            return null;
        var caption = this.renderLocString(this.model.caption);
        return (React.createElement("span", { className: this.model.css.caption, title: this.model.caption.renderedHtml }, caption));
    };
    return SurveyButtonGroupItem;
}(SurveyElementBase));
export { SurveyButtonGroupItem };
// ReactQuestionFactory.Instance.registerQuestion("buttongroup", props => {
//   return React.createElement(SurveyQuestionButtonGroup, props);
// });
